var cate = {
  change:function(cate){
    // $('.cate-menu').removeClass('seled');
    // $('.menu-'+cate).addClass('seled');
    $("html,body").animate({scrollTop:$('#'+cate).offset().top - 40},500);
  },

  //设置图片
  setImgSrc: function () {
    var imgList = document.querySelectorAll('.cate-img img');
    imgList.forEach(function (item) {
      var imgsrc = item.getAttribute('img-data');
      item.setAttribute('src', imgsrc);
    });
  },

  cateContentScroll: function () {
    var $scrollContainer = $('.category-box .right .cate-content');
    var $menuItems = $('.cate-menu');
    var sectionIds = ['cate1', 'cate2', 'cate3', 'cate4', 'cate5'];

    // 监听滚动事件
    $(window).scroll(function () {
      var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;

      // 遍历每个部分，检查是否滚动到了该部分
      $.each(sectionIds, function(index, sectionId) {
        var $section = $('#' + sectionId);
        var sectionOffset = $section.offset().top - $scrollContainer.offset().top;

        // 如果滚动位置在当前部分内（减去一个阈值以提前激活）
        if (scrollTop >= sectionOffset - 10 &&
            (index === sectionIds.length - 1 || scrollTop < $('#' + sectionIds[index + 1]).offset().top - $scrollContainer.offset().top - 10)) {

          // 清除所有菜单项的active样式
          $menuItems.removeClass('seled');

          // 给对应的菜单项添加active样式
          $('.menu-cate' + (index + 1)).addClass('seled');

          // 跳出循环，因为已经找到了对应的部分
          return false;
        }
      });
    });
    // 获取元素
    var cateContent = document.querySelector('.category-box .right .cate-content');

    // 添加scroll事件监听器
    cateContent.addEventListener('scroll', function() {
      // 当cate-content滚动时，这里的代码会被执行
      console.log('cate-content已滚动，滚动位置为:', this.scrollTop);

      // 你可以在这里添加自己的逻辑，比如检查滚动位置等
    });
  },

  init: function () {
    this.setImgSrc();
    this.cateContentScroll();
  }
};

